import _ from 'lodash';
import sanitizeHtml from 'sanitize-html';

export function getTextFromHtml(html: string): string {
  return sanitizeHtml(html, {
    allowedTags: [],
    allowedAttributes: {},
  }).trim();
}

export function getDecodedTextFromHtml(html: string): string {
  return _.unescape(getTextFromHtml(html));
}

export function removeTags(input: string): string {
  if (!input) {
    return '';
  }

  let output = '';
  let insideTag = false;

  for (const ch of input) {
    if (ch === '<') {
      insideTag = true;
      continue;
    }

    if (ch === '>') {
      insideTag = false;
      continue;
    }

    if (!insideTag) {
      output += ch;
    }
  }

  return output;
}

export function trimText(input: string): string {
  if (input.length > 80) {
    return `  ... ${input.substring(input.length - 15, input.length)}`;
  }

  return input;
}

export function cleanUpHtml(html: string): string {
  return sanitizeHtml(html, {
    allowedTags: ['b', 'i', 'em', 'strong', 'a', 'u', 'sup', 'sub', 'strike', 's', 'span'],
    allowedAttributes: {
      a: ['href', 'target', 'title'],
      span: ['style'],
    },
    allowedStyles: {
      span: {
        'white-space': [/^nowrap$/],
      },
    },
    transformTags: {
      i: 'em',
    },
  });
}

export function cleanUpText(text: string): string {
  return sanitizeHtml(text, {
    allowedTags: [],
    disallowedTagsMode: 'recursiveEscape',
  });
}
